import { render, staticRenderFns } from "./zbtts.vue?vue&type=template&id=89e45590&scoped=true"
import script from "./zbtts.vue?vue&type=script&lang=js"
export * from "./zbtts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e45590",
  null
  
)

export default component.exports